<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="changePasswordForm">
      <b-form>
        <b-row>
          <!-- current password -->
          <b-col md="6">
            <InputPasswordField
              id="current-password"
              v-model="userDetails.oldPassword"
              :label="$t('Current Password')"
              :placeholder="$t('Current Password')"
              :error-name="$t('current password')"
              rules="required"
              vid="current password"
            />
          </b-col>
          <!--/ current password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <InputPasswordField
              id="new-password"
              v-model="userDetails.newPassword"
              :label="$t('New Password')"
              :placeholder="$t('New Password')"
              :error-name="$t('new password')"
              rules="required|min:6|upperCaseChar|lowerCaseChar|numberVal|specialChar"
              vid="newPassword"
            />
          </b-col>
          <!--/ new password -->

          <!-- retype password -->
          <b-col md="6">
            <InputPasswordField
              id="retype-password"
              v-model="userDetails.confirmNewPassword"
              class="mb-3"
              :label="$t('Retype New Password')"
              :placeholder="$t('Retype New Password')"
              :error-name="$t('retype new password')"
              rules="required|confirmed:newPassword"
            />
          </b-col>
        </b-row>
        <!--/ retype password -->

        <!-- Questions &amp; Answers -->
        <!-- Security Question 1 -->
        <b-row class="match-height">
          <b-col md="12">
            <b-card-title class="text-title">
              {{ $t('Setup your security questions to further secure your account.') }}
            </b-card-title>
            <div class="business-card">
              <b-row>
                <b-col md="12">
                  <SwitchButton
                    v-model="enableCustomQuestion"
                    :label="$t('Do you wish to create your own questions?')"
                    name="enable-custom-question"
                    class="mt-2"
                    @input="onChangeEventHandler(enableCustomQuestion)"
                  />
                </b-col>
              </b-row>
              <app-collapse
                v-if="enableCustomQuestion === false"
                class="business-items"
                type="margin"
                accordion
              >
                <b-row class="match-height">
                  <b-col md="6">
                    <SelectField
                      id="security-question1"
                      v-model="QuestionsAndAnswers.question1"
                      :label="$t('Security Question 1')"
                      :options="securityQuestionOptions"
                      :error-name="$t('security question 1')"
                      rules="required"
                      :reduce="option => option"
                      item="label"
                      :placeholder="$t('Select a question')"
                      :set-selected="removeItem"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-1"
                      v-model="QuestionsAndAnswers.answer1"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security answer 1')"
                    />
                  </b-col>
                </b-row>
                <!-- Security Question 1-->

                <!-- Security Question 2 -->
                <b-row class="match-height">
                  <b-col md="6">
                    <SelectField
                      id="security-question2"
                      v-model="QuestionsAndAnswers.question2"
                      :label="$t('Security Question 2')"
                      :options="securityQuestionOptions"
                      :error-name="$t('security question 2')"
                      rules="required"
                      :reduce="option => option"
                      item="label"
                      :placeholder="$t('Select a question')"
                      :set-selected="removeItem"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-2"
                      v-model="QuestionsAndAnswers.answer2"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security answer 2')"
                    />
                  </b-col>
                </b-row>

                <!-- Security Question 3 -->
                <b-row class="match-height">
                  <b-col md="6">
                    <SelectField
                      id="security-question3"
                      v-model="QuestionsAndAnswers.question3"
                      :label="$t('Security Question 3')"
                      :options="securityQuestionOptions"
                      :error-name="$t('security question 3')"
                      rules="required"
                      :reduce="option => option"
                      item="label"
                      :placeholder="$t('Select a question')"
                      :set-selected="removeItem"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-3"
                      v-model="QuestionsAndAnswers.answer3"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      error-name="security answer 3"
                    />
                  </b-col>
                </b-row>
              </app-collapse>

              <app-collapse
                v-if="enableCustomQuestion === true"
                class="business-items"
                type="margin"
                accordion
              >
                <b-row class="match-height">
                  <b-col md="6">
                    <InputField
                      id="security-question1"
                      v-model="QuestionsAndAnswers.question1"
                      :label="$t('Security Question 1')"
                      :placeholder="$t('Security question')"
                      type="text"
                      rules="required|min:2|max:250"
                      error-name="security question 1"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-1"
                      v-model="QuestionsAndAnswers.answer1"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security answer 1')"
                    />
                  </b-col>
                </b-row>
                <b-row class="match-height">
                  <b-col md="6">
                    <InputField
                      id="security-question2"
                      v-model="QuestionsAndAnswers.question2"
                      :label="$t('Security Question 2')"
                      :placeholder="$t('Security question')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security question 2')"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-2"
                      v-model="QuestionsAndAnswers.answer2"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security answer 2')"
                    />
                  </b-col>
                </b-row>
                <b-row class="match-height">
                  <b-col md="6">
                    <InputField
                      id="security-question3"
                      v-model="QuestionsAndAnswers.question3"
                      :label="$t('Security Question 3')"
                      :placeholder="$t('Security question')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security question 3')"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="answered-question-3"
                      v-model="QuestionsAndAnswers.answer3"
                      :label="$t('What\'s your answer?')"
                      :placeholder="$t('Enter your answer')"
                      type="text"
                      rules="required|min:2|max:250"
                      :error-name="$t('security answer 3')"
                    />
                  </b-col>
                </b-row>

              </app-collapse>
            </div>
          </b-col>
        </b-row>

        <!-- buttons -->
        <!-- submit button -->
        <div class="mt-3 d-flex justify-content-center align-items-center">
          <Button
            :label="$t('Save changes')"
            size="lg"
            block
            :loading="isLoading"
            :disabled="isDisabled"
            @click="handleSubmit"
          />
          <Button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            :label="$t('Reset')"
            size="lg"
            block
            class="ml-1"
            variant="outline-secondary"
            @click="resetForm"
          />
        </div>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  BForm, BRow, BCol, BCard, BCardTitle,
} from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { toastAlert } from '@core/mixins/toast'
import { mapGetters, mapActions } from 'vuex'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import Button from '../../components/button/Button.vue'
import InputField from '../../forms/InputField.vue'
import InputPasswordField from '../../forms/InputPasswordField.vue'
import SelectField from '../../forms/SelectField.vue'
import { securityQuestions } from '../../../helpers/data'
import SwitchButton from '../../components/switch/Switch.vue'

export default {
  components: {
    BCardTitle,
    BForm,
    BRow,
    BCol,
    BCard,
    InputPasswordField,
    ValidationObserver,
    Button,
    InputField,
    SelectField,
    SwitchButton,
    AppCollapse,
  },
  directives: {
    Ripple,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      userDetails: {
        email: '',
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      },
      QuestionsAndAnswers: {
        question1: '',
        question2: '',
        question3: '',
        answer1: '',
        answer2: '',
        answer3: '',
      },
      isLoading: false,
      isDisabled: false,
      enableCustomQuestion: false,
      required,
      // securityQuestionOptions: securityQuestions,
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    securityQuestionOptions() {
      return securityQuestions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  methods: {
    ...mapActions({
      modifySecurityDetails: 'auth/modifySecurityDetails',
    }),
    removeItem(index) {
      const indexNumber = this.securityQuestionOptions.indexOf(index)
      this.securityQuestionOptions.splice(indexNumber, 1)
    },
    handleSubmit() {
      this.$refs.changePasswordForm.validate().then(success => {
        if (success) {
          this.confirm(this.changeUserPassword, { text: this.$t(this.$t('Are you sure you want to Change your Password?')) })
        }
      })
    },
    async changeUserPassword() {
      try {
        this.isDisabled = true
        this.isLoading = true
        await this.modifySecurityDetails({
          ...this.userDetails,
          ...this.QuestionsAndAnswers,
          email: this.userData.email,
        })
          .then(() => {
            this.$router
              .push({ name: 'auth-login' })
            this.toastAlert({
              title: this.$t('Success'),
              icon: 'CoffeeIcon',
              variant: 'success',
              text: this.$t('You have successfully changed your password'),
            })
          })
        this.isDisabled = false
        this.isLoading = false
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isDisabled = false
        this.isLoading = false
      }
    },
    onChangeEventHandler(event) {
      if (event === true) {
        this.QuestionsAndAnswers = { ...null }
      } else {
        this.QuestionsAndAnswers = { ...null }
      }
    },
    resetForm() {
      this.userDetails = { ...null }
      this.QuestionsAndAnswers = { ...null }
    },
  },
}
</script>

<style scoped>
  .text-title {
    font-size: 1.2em;
    font-weight: 700;
  }
</style>
